export default __webpack_public_path__ + "static/media/task_home.f10e96f3.svg";